import { render, staticRenderFns } from "./_payments.vue?vue&type=template&id=5a9e9d41&scoped=true&"
import script from "./_payments.vue?vue&type=script&lang=js&"
export * from "./_payments.vue?vue&type=script&lang=js&"
import style0 from "./_payments.vue?vue&type=style&index=0&id=5a9e9d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e9d41",
  null
  
)

export default component.exports